module.exports = __webpack_public_path__ + "img/PT.57ce36ac.webp";